import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FilterTransactionsPageRoutingModule } from './filter-transactions-routing.module';

import { FilterTransactionsPage } from './filter-transactions.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FilterTransactionsPageRoutingModule
  ],
  declarations: [FilterTransactionsPage]
})
export class FilterTransactionsPageModule {}
